package amazon.lastmile.inject

import app.nestbridge.domain.ping.api.PingApiClient
import app.nestbridge.domain.ping.api.RemotePingApiClient
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = RemotePingApiClient::class)
public interface AppNestbridgeDomainPingApiRemotePingApiClient {
  @Provides
  public fun provideRemotePingApiClientPingApiClient(remotePingApiClient: RemotePingApiClient): PingApiClient = remotePingApiClient
}
